import MessagingTemplateCollection from './messagingTemplateCollection.container';

export default MessagingTemplateCollection;
